import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import analizeRideStatus from '../../utils/analizeRideStatus';
import DriverInfo from '../RideComponents/DriverInfo';
import AddressInfo from '../RideComponents/AddressInfo';
import SupportEmail from './SupportEmail';
import CancelRide from '../RideComponents/CancelRide';
import '../../assets/styles/active-ride-details.sass';
import { ReactComponent as Sending } from '../../assets/img/sending.svg';
import { ReactComponent as ContactingDriver } from '../../assets/img/contacting-driver.svg';
import { ReactComponent as AdditionalDriver } from '../../assets/img/additional-driver.svg';
import { ReactComponent as HangIn } from '../../assets/img/hang-in.svg';

const ActiveRideDetails = () => {
  const { ride } = useContext(BookerShortContext);
  const { state: rideStatus, vehicle_number, eta } = ride || {};
  const { key, title, etaMins, statusMessage, statusItem } = analizeRideStatus(rideStatus, eta);

  const statusItemList = [
    {
      id: 1,
      icon: <Sending />,
      active: statusItem,
      isVisible: statusItem === 1,
    },
    {
      id: 2,
      icon: <ContactingDriver />,
      active: statusItem > 1,
      isVisible: statusItem === 2,
    },
    {
      id: 3,
      icon: <AdditionalDriver />,
      active: statusItem > 2,
      isVisible: statusItem === 3,
    },
    {
      id: 4,
      icon: <HangIn />,
      active: statusItem > 3,
      isVisible: statusItem === 4,
    },
  ];

  if (!ride || key === 'enrouteRideState') return <></>;

  return (
    <div className="active-ride-details">
      <div className="active-ride-title">
        <div className="title">
          {title} {etaMins && <span className="eta-mins">ETA {etaMins} Mins</span>}
        </div>
        <div className="eta-message">{statusMessage}</div>
        {statusItem && (
          <div className="status-requested">
            {statusItemList.map(item => (
              <span
                key={item.id}
                className={`status-requested-item ${item.active ? 'active' : ''} ${item.isVisible ? 'blinked' : ''}`}
              />
            ))}
          </div>
        )}
      </div>

      <>
        {key === 'requestingRide' && (
          <div className="status-requested-icon">
            {statusItemList.map(item => (
              <span key={item.id} className={`status-image ${item.isVisible ? 'active' : ''}`}>
                {item.icon}
              </span>
            ))}
          </div>
        )}

        {key !== 'requestingRide' && (
          <div className="active-ride-address">
            <AddressInfo />
          </div>
        )}
        <div className="active-ride-footer">
          {key !== 'requestingRide' && (
            <>
              <DriverInfo />
              {vehicle_number && <SupportEmail />}
            </>
          )}
          <CancelRide />
        </div>
      </>
    </div>
  );
};

export default ActiveRideDetails;
